import { useMutation, UseMutationOptions } from "@tanstack/react-query";

import { useUnauthenticatedServer } from "../../server/ServerContext";
import { PortalAxiosError } from "../../types";
import { ResetPasswordResponse, ResetPasswordVariables } from "./types";

/**
 *
 * @param options useMutation options
 * @returns useMutation result
 */
export const useResetPassword = (
  options?: UseMutationOptions<
    ResetPasswordResponse,
    PortalAxiosError,
    ResetPasswordVariables
  >
) => {
  const unauthenticatedServer = useUnauthenticatedServer();

  return useMutation<
    ResetPasswordResponse,
    PortalAxiosError,
    ResetPasswordVariables
  >(
    (variables) => unauthenticatedServer.post("auth/reset_password", variables),
    options
  );
};

export default useResetPassword;
